import React from "react";

export type Option = {
  option: React.ReactNode;
  value: string;
};

type SelectProps = React.DetailedHTMLProps<
  React.SelectHTMLAttributes<HTMLSelectElement>,
  HTMLSelectElement
> & { options: Option[] };

export const DealerTypeOptions: Option[] = [
  { option: "Select Dealer Type", value: "" },
  { option: "RV", value: "RV" },
  { option: "Trailer", value: "TR" },
  { option: "Auto", value: "AU" },
  { option: "Marine", value: "MA" },
  { option: "Motorboats", value: "MA" },
  { option: "Powersport", value: "PS" },
  { option: "Equipment", value: "EQ" },
  { option: "Service", value: "SV" },
  { option: "Internal", value: "IN" },
  { option: "Heavy Equipment", value: "HE" }
];

export const NewCustomerSelect = React.forwardRef<
  HTMLSelectElement,
  SelectProps
>(({ options, ...props }, ref) => (
  <select ref={ref} {...props}>
    {options.map(({ option, value }, index: number) => (
      <option key={index} value={value}>
        {option}
      </option>
    ))}
  </select>
));
